/**
 * Converts a numeric rupee amount to Indian word format.
 * e.g. 457250 → "Four Lakh Fifty Seven Thousand Two Hundred And Fifty only."
 */

const ones = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
    'Seventeen', 'Eighteen', 'Nineteen',
];

const tens = [
    '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety',
];

function convertHundreds(n: number): string {
    if (n === 0) return '';
    if (n < 20) return ones[n];
    if (n < 100) {
        const t = Math.floor(n / 10);
        const o = n % 10;
        return tens[t] + (o ? ' ' + ones[o] : '');
    }
    const h = Math.floor(n / 100);
    const rem = n % 100;
    return ones[h] + ' Hundred' + (rem ? ' ' + convertHundreds(rem) : '');
}

function convertIndian(n: number): string {
    if (n === 0) return 'Zero';
    const crore = Math.floor(n / 10_000_000);
    n %= 10_000_000;
    const lakh = Math.floor(n / 100_000);
    n %= 100_000;
    const thousand = Math.floor(n / 1_000);
    n %= 1_000;

    let result = '';
    if (crore) result += convertHundreds(crore) + ' Crore ';
    if (lakh) result += convertHundreds(lakh) + ' Lakh ';
    if (thousand) result += convertHundreds(thousand) + ' Thousand ';
    if (n) result += convertHundreds(n);
    return result.trim();
}

export function amountInWords(amount: number): string {
    if (!amount || isNaN(amount)) return '';
    const rupees = Math.floor(amount);
    const paisa = Math.round((amount - rupees) * 100);

    let result = convertIndian(rupees) + ' Rupees';
    if (paisa > 0) {
        result += ' And ' + convertHundreds(paisa) + ' Paise';
    }
    return result + ' only.';
}
